import { useMemo } from 'react';
export function isToken(token) {
    return (typeof token === 'object' &&
        token !== null &&
        'id' in token &&
        'type' in token &&
        token.type === 'token');
}
export function useTokenData(id, data) {
    return useMemo(() => ({
        id,
        type: 'token',
        data,
    }), [id, data]);
}
//# sourceMappingURL=types.js.map